import React from 'react'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'
import LineClockDollarIcon from 'components/Luxkit/Icons/line/LineClockDollarIcon'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { getPaymentDueDate, isOfferDefaultDepositAmountPercentage } from 'lib/depositsUtils'
import useToggle from 'hooks/useToggle'
import { DepositInfoModal } from 'components/Common/DepositInfo/DepositInfoModal'
import depositAmountStringBuilder from 'lib/TourV2/depositAmountStringBuilder'

import { getDefaultDepositAmountPercentage } from 'checkout/selectors/featureConfig/deposit'
import { useAppSelector } from 'hooks/reduxHooks'

const Container = styled.div`
  background-color: ${props => props.theme.palette.highlight.primary.light};
  border-radius: ${props => props.theme.borderRadius.large};
  display: flex;
  padding: ${rem(16)};
`

const RightSide = styled.div`
  margin-left: ${rem(16)};

  ${mediaQueryUp.tablet} {
    display: flex;
    align-items: baseline;
  }
`

const StyledTextLink = styled(TextLink)`
  margin-left: ${rem(8)};
`

interface Props {
  offerType: App.OfferType;
  depositAmountPercentage: number
  depositThresholds?: App.DepositThreshold
  depositType?: Tours.V2OfferDepositType
  depositAmount?: number;
}

export function SecureWithDepositBanner({ offerType, depositAmountPercentage, depositThresholds, depositType, depositAmount }: Props) {
  const paymentDueDaysBeforeCheckin = getPaymentDueDate(depositThresholds, offerType)
  const [isPolicyOpen, , openPolicy, closePolicy] = useToggle()

  const defaultDepositAmountPercentage = useAppSelector(getDefaultDepositAmountPercentage)

  const isOfferUsingDefaultDepositPercentage = isOfferDefaultDepositAmountPercentage(depositThresholds, depositAmount)

  const depositAmountString = isOfferUsingDefaultDepositPercentage ?
    '' : !depositType ? ` ${depositAmountPercentage}%` : !depositThresholds ? ` ${depositAmountStringBuilder(defaultDepositAmountPercentage, depositType, depositAmountPercentage).short}` : ''

  return (
    <>
      <Container>
        <LineClockDollarIcon colour="primary" />
        <RightSide>
          <BodyText variant="large">Secure with a
            {!depositType && <BodyText as="span" variant="large" weight="bold">{depositAmountString} deposit&nbsp;</BodyText>}
            {!depositThresholds && depositType && <BodyText as="span" variant="large" weight="bold">{depositAmountString} deposit&nbsp;</BodyText>}
            and pay the rest {paymentDueDaysBeforeCheckin} days before your escape.&nbsp;
          </BodyText>
          <StyledTextLink onClick={openPolicy} size="large">Find out more</StyledTextLink>
        </RightSide>
      </Container>
      <DepositInfoModal
        isModalOpen={isPolicyOpen}
        offerType={offerType}
        onCloseModal={closePolicy}
        depositAmountPercentage={depositAmountPercentage}
        depositThresholds={depositThresholds}
        depositType={depositType}
        depositAmount={depositAmount}
      />
    </>
  )
}
